<template>
  <div id="app">
	  <transition :name="animate">
	    <router-view id="view" :class="{tab:$route.meta.tab}"></router-view>
    </transition>
    <div class="bottomTab flex a-center" :class="{active:$route.meta.tab}" v-if="false">
      <div class="item flex a-center" :class="{active:$route.name=='personal'}" @click="go('personal')">
        <div>
          <i class="iconfont icon--fenceng"></i>
          <p>设备</p>
        </div>
      </div>
      <div class="item flex a-center" :class="{active:$route.name=='package'}" @click="go('package')">
        <div>
          <i class="iconfont icon-chongzhi1"></i>
          <p>充值</p>
        </div>
      </div>
      <div class="item flex a-center" :class="{active:$route.name=='userInfo'}" @click="go('userInfo')">
        <div>
          <i class="iconfont icon-user"></i>
          <p>我的</p>
        </div>
      </div>
    </div>
    <loading v-if="loadingShow"></loading>
  </div>
</template>

<script>
import { trackSubmit } from '@/utils/track'
export default {
  name: 'App',
  data () {
      return {
        animate : '',
        loadingShow:"",
        entranceArr: [
          {path:'/personal', val: 'normal'},
          {path: '/device', val: 'first'},
          {path: '/fastLogin', val: 'fast'},
          {path: '/bind-equipment', val: 'account'}
        ],
    }
  },
  watch : {
    $route (to , from) {
      sessionStorage.setItem('mifiBeforeRoute',from.path ? `${from.path}----${from.meta.title||'登录'}`:'--')
      this.handleEntrance(to.path);
      if(to.path && ['/','/device','/realName-index','/scanCode'].includes(to.path)){
        trackSubmit({eventCode:to.meta.eventCode})
      }
      /*
       0: 不做动画
       1: 左切换
       2: 右切换
       3: 上切换
       4: 下切换
       */
      let animate = this.$router.animate || to.meta.slide

      if(!animate) {
        this.animate = 'slide'
      } else {
        this.animate = animate === 1 ? 'slide-left' :
          animate === 2 ?  'slide-right' :
          animate === 3 ?  'slide-top' :
          animate === 4 ?  'slide-bottom' : ''
      }

      if(to.meta.bankbtn){
        this.$router.bankbtn = to.meta.bankbtn
      }else {
        this.$router.bankbtn = 0
      }
      this.$router.animate = 0
    },
    loading(newVal,oldVal){
    	this.loadingShow = this.$store.state.showLoading
    }
  },
  computed:{
  	loading(){
  		return this.$store.state.showLoading
    }
  },
  created(){
    this.getTrackStatus();
    this.judgePlatform()
    this.getVisitorId()
  },
  methods:{
    handleEntrance(path){
      // personal  device(登录后无设备) fastLogin  bind-equipment（公众号）
      if(!path) return;
      let entrance = ''
      let obj = this.entranceArr.find(v=> v.path == path)
      entrance = obj ? obj.val : null
      entrance && sessionStorage.setItem('mifiEntrance',entrance)
    },
    getVisitorId(){
      if(sessionStorage.getItem('mifiVisitorId')) return ;
      const fpPromise = import('@fingerprintjs/fingerprintjs')
      .then(FingerprintJS => FingerprintJS.load())
      fpPromise
      .then(fp => fp.get())
      .then(result => {
        const visitorId = result.visitorId
        sessionStorage.setItem('mifiVisitorId',visitorId)
      })
    },
    getTrackStatus(){
      if(sessionStorage.getItem('buriedStatus')) return;
      this.$http.get('/marketOrder/buriedStatus')
      .then(({data})=>{
        if(data.code == 200){
          sessionStorage.setItem('buriedStatus',data.data);
        }
      })
    },
    go(name){
      this.$router.push({
        name
      })
    },
    judgePlatform(){
      if (/MicroMessenger/.test(window.navigator.userAgent)) { 
        this.device = 'wx'
        this.$store.commit('Login',{
          deviceType:'wx'
        })
      } else if (/AlipayClient/.test(window.navigator.userAgent)) { 
        this.device = 'ali'
        this.$store.commit('Login',{
          deviceType:'ali'
        })
      } else {
        this.device = 'other'
        this.$store.commit('Login',{
          deviceType:'other'
        })
      }
    }
  }
}
</script>

<style>
#app{
	height: 100vh;
}
.bottomTab{
  height: 50px;
  position: fixed;
  width: 100vw;
  bottom :-120px;
  left :0;
  justify-content: space-around;
  border-top: 1px solid #F6F7FA;
  transition: all 0.25s;
  background: #fff;
  z-index: 99;
}
.bottomTab .item{
  text-align: center;
  font-size: 0;
}
.bottomTab .item p{
  margin: 0;
  font-size: 12px;
}
.bottomTab .item i{
  font-size: 24px;
  margin: 0;
}
.bottomTab.active{
  bottom: 0;
}
.bottomTab .item.active i,.bottomTab .item.active p{
  color: #4367FD;
}
#view{
  position:  absolute;
  left:  0;
  top:  0;
  width:  100%;
  height:  100%;
  transition:  all .3s cubic-bezier(0.55, 0, 0.1, 1);
  overflow-y:auto ;
}
#view.tab{
  /* padding-bottom: 50px; */
}
.slide-enter, .slide-leave-active{
  transition : opacity .25s;
}
.slide-leave-active, .slide-enter{

  opacity: 0;
}
.slide-left-enter, .slide-right-leave-active{

  opacity:  0;
  transform:  translate(100%, 0);
}
.slide-left-leave-active, .slide-right-enter{

  opacity: 0;
  transform: translate(-100%, 0);
}
.slide-top-enter, .slide-bottom-leave-active{
  opacity : 0;
  transform : translate(0, 100%);
}
.slide-top-leave-active, .slide-bottom-enter{
  opacity: 0;
  transform: translate(0, -100%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue